import { useEffect, useState } from 'react';
import { ColorRing } from 'react-loader-spinner';

import { useGetTableMCTColumns } from '../TableMCT/useGetTableMCTColumns';
import TrapDeviceExpandable from '../TableMCT/TableMCTExpandable';

import { TrapDevice } from 'api/traps/DevicesWareHouse/types';
import FilterDataTable from 'components/FilterDataTable/FilterDataTable';
import useScreenSize from 'hooks/Screen/useScreenSize';
import SnapTrapRatIcon from 'components/Icons/SnapTrapRatIcon';
import { TrapType } from 'components/AnalyticsPage/TrapType';

interface Props {
  data: TrapDevice[] | undefined;
  isLoading: boolean;
  isRefetching: boolean;
  isAll: boolean;
  refetch: () => void;
}

const TableSTR: React.FC<Props> = ({ isAll, data, isLoading, isRefetching, refetch }) => {
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');
  const columns = useGetTableMCTColumns(isAll, TrapType.SRST);
  const { isNotLargeDesktop, isNotMobile } = useScreenSize();

  useEffect(() => {
    refetch();
  }, [page, ordering, search, refetch]);

  return (
    <div className="flex-fill">
      {(isLoading || isRefetching) && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1001,
          }}
        >
          <ColorRing
            visible
            height="80"
            width="80"
            ariaLabel="color-ring-loading"
            wrapperStyle={{}}
            wrapperClass="color-ring-wrapper"
            colors={['#9C7AE2', '#E27A8C', '#C0E27A', '#7AE2D0', '#F7F18F']}
          />
        </div>
      )}
      <div className="bg-white">
        <FilterDataTable<TrapDevice>
          columns={columns}
          data={data || []}
          title="Snap trap (rat)"
          iconComponent={<SnapTrapRatIcon />}
          isMinHeight
          onChangePage={setPage}
          onChangeFilterParams={setQueryParam}
          onChangeSearch={setSearch}
          isLoading={isLoading}
          expandableRows={isAll ? isNotLargeDesktop : isNotMobile}
          expandableRowsComponent={row => <TrapDeviceExpandable data={row.data} isAll={isAll} />}
        />
      </div>
    </div>
  );
};

export default TableSTR;
